import { useCallback } from 'react'

interface UseImportScriptReturn {
  loadScript: (
    resourceUrl: string,
    async: boolean,
    loggedIn: boolean,
    additionalAttributes?: Record<string, string>,
  ) => (() => void) | undefined
}

const useImportScript = (): UseImportScriptReturn => {
  const loadScript = useCallback(
    (
      resourceUrl: string,
      async: boolean = true,
      loggedIn: boolean,
      additionalAttributes: Record<string, string> = {},
    ) => {
      if (loggedIn) {
        const script = document.createElement('script')
        script.src = resourceUrl
        if (async) {
          script.async = async
        }
        for (const [key, value] of Object.entries(additionalAttributes)) {
          script.setAttribute(key, value)
        }
        document.body.appendChild(script)
        return () => {
          document.body.removeChild(script)
        }
      }
    },
    [],
  )

  return {
    loadScript,
  }
}

export default useImportScript
